export default "__VITE_ASSET__CjwhbBxN__"